import { EntityApi } from "../../services/ApiPlatform";

export abstract class TimesheetTypeApi extends EntityApi {
    protected static GET_COLLECTION = "/api/timesheet-types";

    protected static POST_COLLECTION = "/api/timesheet-types";

    protected static GET_ITEM = "/api/timesheet-types/{id}";

    protected static PUT_ITEM = "/api/timesheet-types/{id}";

    protected static PATCH_ITEM = "/api/timesheet-types/{id}";

    protected static DELETE_ITEM = "/api/timesheet-types/{id}";
}
